const Storage = {
    SetToken: (data) => localStorage.setItem("token", JSON.stringify(data)),
    getToken: () => localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : null,
    SetUserData: (data) => localStorage.setItem("userData", JSON.stringify(data)),
    getUserData: () => localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null,
    removeData: (key) => localStorage.removeItem(key)
};

export default Storage;